import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ValidationService } from '@shared/services/validation.service';

@Component({
  selector: 'app-control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss']
})
export class ControlMessagesComponent {
  @Input() public control!: UntypedFormControl;
  @Input() public labelName?: string;
  translations: any;

  constructor(
    private validationService: ValidationService) {
  }

  get errorMessages(): Array<string> {
    const errors: string[] = [];
    if (this.control && this.control.errors) {
      for (const propertyName in this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) && (this.control.touched && this.control.dirty)) {
          errors.push(
            this.validationService.getValidationErrorMessage(
              propertyName,
              this.control.errors[propertyName],
              this.labelName,
            )
          );
        }
      }
    }
    return errors;
  }
}
